import {EventBus} from '@/common/helpers/utils/EventBus';

type EmittedError = unknown;

export type ErrorInformerEmitter = EventBus<EmittedError>;

export const createErrorInformerEmitter = (): ErrorInformerEmitter => {
	return new EventBus();
};
